export default "__VITE_ASSET__DxAfp4uo__"